<template lang="html">
  <div class="cw-box-info">
    <section class="hero is-small">
      <div class="hero-body">
        <div class="media">
          <div class="media-left"></div>
          <div class="media-content">
            <h1 class="title is-size4 is-size5-mobile">
              {{ project.name }}
            </h1>
            <h2 class="subtitle is-size6-mobile">
              {{ project.address.street }}
            </h2>
          </div>
          <div class="media-right">
            <span class="tag is-steel is-large">
              {{
                (boxSetInfo.box && boxSetInfo.box.boxSize) || boxSetInfo.boxSize
              }}
              {{
                (this.boxSetInfo &&
                  this.boxSetInfo.intendedUse.toLowerCase() !== 'washout' &&
                  'yd') ||
                  ''
              }}
            </span>
          </div>
        </div>
      </div>
    </section>
    <section class="section is-top-paddingless is-pad-bottom-1">
      <div
        class="columns is-mobile has-dividers has-border-top has-border-bottom is-padded-small is-horizontal-paddingless is-marginless"
      >
        <div class="column is-size-5">
          <p class="has-text-grey-light">Lot No.</p>
          <p>
            {{ (boxSetInfo.subProject && boxSetInfo.subProject.name) || 'n/a' }}
          </p>
        </div>
        <div class="column is-size-5">
          <p class="has-text-grey-light">Box</p>
          <p>{{ (boxSetInfo.box && boxSetInfo.box.boxNumber) || 'none' }}</p>
        </div>
        <div class="column is-size-5">
          <p class="has-text-grey-light">Use</p>
          <p>{{ detailsInfo.intendedUse || 'n/a' }}</p>
        </div>
      </div>
      <div
        v-if="displayDateCreated"
        class="is-size-5 has-border-bottom is-padded-medium"
      >
        <p class="has-text-grey-light">Order Created</p>
        <p>{{ displayDateCreated }}</p>
      </div>
      <div
        v-if="orderedByName"
        class="is-size-5 has-border-bottom is-padded-medium"
      >
        <p class="has-text-grey-light">Ordered by</p>
        <p>{{ orderedByName }}</p>
      </div>
      <div class="is-size-5 has-border-bottom is-padded-medium">
        <p class="has-text-grey-light">Date Set</p>
        <p>{{ boxSetInfo.dateSet || 'not available' }}</p>
      </div>
      <div
        v-if="poRequired"
        class="is-size-5 has-border-bottom is-padded-medium"
      >
        <p class="has-text-grey-light">Purchase Order</p>
        <p>
          {{ (boxSetInfo.poAssigned && 'PO Assigned') || 'none specified' }}
        </p>
      </div>
      <div class="is-size-5 has-border-bottom is-padded-medium">
        <p class="has-text-grey-light">Special Instructions</p>
        <p>{{ detailsInfo.specialInstructions || 'not available' }}</p>
      </div>
      <div
        v-if="detailsInfo.respotReason"
        class="is-size-5 has-border-bottom is-padded-medium"
      >
        <p class="has-text-grey-light">Respot Reason</p>
        <p>{{ detailsInfo.respotReason }}</p>
      </div>
    </section>
    <p
      class="is-size-6 has-text-grey-medium has-text-centered is-padded-medium"
    >
      Work Order {{ boxSetInfo.workOrderId }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'cw-box-info',

  props: {
    boxSetInfo: {
      type: Object,
      required: true,
    },

    displayOrderInfo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {};
  },

  computed: {
    project() {
      return (
        (this.boxSetInfo && this.boxSetInfo.project) || {
          name: '',
          address: { street: '' },
        }
      );
    },

    detailsInfo() {
      let info = this.boxSetInfo;

      if (info && this.displayOrderInfo && info.dispatchPull) {
        info = { ...info, ...this.boxSetInfo.dispatchPull };
      }
      return info;
    },

    // FileMaker returns RecordCreated as a full timestamp (e.g.
    // 04/04/2024 21:37:21). Trim to the date part for display, matching
    // how other date fields render in this view.
    displayDateCreated() {
      const created = this.boxSetInfo && this.boxSetInfo.dateCreated;
      return (created && `${created}`.split(' ')[0]) || '';
    },

    // The dispatch set's contact is the primary source; fall back to the
    // staged order's user for orders with no contact recorded. Only admins
    // receive either value (see the server's viewOrderedBy gate).
    orderedByName() {
      const info = this.boxSetInfo;
      const stagedOrderName =
        (info && info.stagedOrder && info.stagedOrder.userName) || '';
      return (info && info.orderedByName) || stagedOrderName;
    },

    poRequired() {
      return (
        this.$store.state.user.customer &&
        this.$store.state.user.customer.requiresPO
      );
    },
  },
};
</script>

<style lang="" scoped></style>
